'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = insurancesSaga;

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _insurances = require('../actions/insurances');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getInsuranceProviders),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getEntityInsuranceProviders),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(insurancesSaga);

function getInsuranceProviders(payload) {
  var insuranceProviders, insuranceProvidersResponse;
  return _regenerator2.default.wrap(function getInsuranceProviders$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          insuranceProviders = new _webUtils.API();
          _context.next = 3;
          return insuranceProviders.get('' + _webUtils.Urls.getInsuranceProvidersByCountryId + payload.countryId, undefined, true);

        case 3:
          insuranceProvidersResponse = _context.sent;

          if (!_webUtils.STATUS.isSuccess(insuranceProvidersResponse.status)) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return (0, _effects.put)({ type: _insurances.INSURANCES.SUCCESS, insuranceProviders: insuranceProvidersResponse.data });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)({ type: _insurances.INSURANCES.FAIL });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getEntityInsuranceProviders(payload) {
  var api, response;
  return _regenerator2.default.wrap(function getEntityInsuranceProviders$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          api = new _webUtils.API();
          _context2.next = 3;
          return api.get(_webUtils.Urls.getEntityVDoc + '/' + payload.entityKey + '/insurances');

        case 3:
          response = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context2.next = 9;
            break;
          }

          _context2.next = 7;
          return (0, _effects.put)((0, _insurances.loadEnityInsuranceProvidersSuccess)(_extends({}, response.response)));

        case 7:
          _context2.next = 11;
          break;

        case 9:
          _context2.next = 11;
          return (0, _effects.put)((0, _insurances.loadEnityInsuranceProvidersFail)());

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function insurancesSaga() {
  return _regenerator2.default.wrap(function insurancesSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_insurances.INSURANCES.LOAD, getInsuranceProviders);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(_insurances.ENTITY_INSURANCES.LOAD, getEntityInsuranceProviders);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}
module.exports = exports['default'];